var render, staticRenderFns
import script from "./takeStock.vue?vue&type=script&lang=js&"
export * from "./takeStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab67212",
  null
  
)

export default component.exports